define('modules/priceXhr',[], 
  function (Module) {
      return {
          xhrList: []
      };
  });
